module.exports = __webpack_public_path__ + "static/media/google-play.f347005b.svg";